import React from 'react';
import { ComposedChart, Line, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Label } from 'recharts';
import styles from "./barAndLineComboChart.module.css";

const BarAndLineComboChartAgileOr = ({ details, capsuleData }) => {

    const formatDate = (dateString) => {
        const options = { day: 'numeric', month: 'short' };
        const date = new Date(dateString?.split('-')?.reverse()?.join('-'));
        return date.toLocaleDateString('en-US', options);
    };

    const transformedData = details?.map(item => ({
        date: formatDate(item["Date"]),
        agilePlanValue: item["Agile plan"]?.value || 0,
        productionActuals: item["Production actuals (tonnes)"] || 0,
        wtdPercentage: item.hasOwnProperty("WTD (%)") ? parseFloat(item["WTD (%)"]) : undefined
    }));

    const CustomLegend = (props) => {
        const { payload } = props;
        return (
            <div style={{ display: 'flex', justifyContent: 'left', padding: '10px' }}>
                {payload.map((entry, index) => {
                    const { value, color } = entry;
                    return (
                        <span
                            key={`item-${index}`}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                padding: '0 10px',
                            }}
                        >
                            <span
                                style={{
                                    backgroundColor: color,
                                    width: '6px',
                                    height: '12px',
                                    display: 'inline-block',
                                    borderRadius: '2px',
                                }}
                            />
                            <span style={{ color: '#4D4D4F' }}>{value}</span>
                        </span>
                    );
                })}
            </div>
        );
    };

    const legendStyle = {
        fontSize: '10px',
        paddingTop: '15px',
        color: '#4D4D4F',
    };

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            return (
                <div className={styles.customTooltip}>
                    {payload.map((item, index) => (
                        <p key={index} className={styles.tooltipItem}>
                            <span style={{ fontWeight: 600 }}>{item.name}</span>&nbsp; : &nbsp;
                            {item.name.includes('WTD') ? `${item.value}%` : item.value}
                        </p>
                    ))}
                </div>
            );
        }
        return null;
    };

    const Box = ({ label, value, unit }) => {
        return (
            <div className={styles.box}>
                <span className={styles.label}>{label}: &nbsp;</span>
                <span className={styles.value}>{value} {unit}</span>
            </div>
        );
    };

    return (
        <>
            <div className={styles.boxContainer}>
                <Box label="Projected OR" value={parseFloat(capsuleData["Agile OR"] || 0).toFixed(1)} unit="%" />
                <Box label="Total plan" value={parseFloat(capsuleData["Total plan"] || 0).toFixed(1)} unit="T" />
                <Box label="Projected loss" value={parseFloat(capsuleData["Projected loss"] || 0).toFixed(1)} unit="T" />
                <Box label="Overall RMPM coverage" value={parseFloat(capsuleData["Overall RMPM coverage"] || 0).toFixed(1)} unit="%" />
                <Box label="Physical RMPM coverage" value={parseFloat(capsuleData["Physical RMPM coverage"] || 0).toFixed(1)} unit="%" />
            </div>

            <ResponsiveContainer width="100%" height={220}>
                <ComposedChart data={transformedData}
                    margin={{
                        top: 10,
                        right: 0,
                        bottom: 10,
                        left: 0,
                    }} >
                    <CartesianGrid strokeDasharray="3 3" vertical={false} horizontal={true} />
                    <XAxis dataKey="date" tickLine={false} axisLine={false} className={styles.BarLabel} padding={{ left: 0, right: 0 }} >
                        <Label value="Current Week" offset={10} position="bottom" style={{ fill: '#2B2B2B', fontSize: '10px', fontWeight: '500' }} />
                    </XAxis>
                    <YAxis domain={[0, 'auto']} tickLine={false} axisLine={false} className={styles.BarLabel} padding={{ left: 0, right: 0 }} />
                    <Tooltip
                        content={<CustomTooltip />}
                        wrapperStyle={{
                            fontSize: '12px',
                            padding: '6px',
                        }}
                    />
                    <Legend verticalAlign="bottom" align="left" wrapperStyle={legendStyle} content={<CustomLegend />} />

                    <Bar
                        radius={[4, 4, 0, 0]}
                        dataKey="agilePlanValue"
                        name="Agile plan (tonnes)"
                        fill="#005EEF"
                        barSize={20}
                    />
                    <Bar
                        dataKey="productionActuals"
                        name="Production actuals (tonnes)"
                        fill="#00B190"
                        barSize={20}
                        radius={[4, 4, 0, 0]}
                    />
                    <Line type="monotone" dataKey="wtdPercentage" name="WTD (%)" stroke="#FF544F" fill="#FF544F" strokeWidth={1} />
                </ComposedChart>
            </ResponsiveContainer>
        </>
    );
};

export default BarAndLineComboChartAgileOr;